'use strict'

exports.AT = require('./austria.json')
//exports.BE = require('./belgium.json')
exports.BG = require('./bulgaria.json')
exports.HR = require('./croatia.json')
//exports.FR = require('./france.json')
exports.DE = require('./germany.json')
exports.GR = require('./greece.json')
//exports.HU = require('./hungary.json')
//exports.IT = require('./italy.json')
//exports.LU = require('./luxembourg.json')
exports.NL = require('./netherlands.json')
//exports.PL = require('./poland.json')
//exports.PT = require('./portugal.json')
exports.RO = require('./romania.json')
//exports.ES = require('./spain.json')
exports.SI = require('./slovenia.json')
exports.SE = require('./sweden.json')
exports.CH = require('./switzerland.json')
exports.TR = require('./turkey.json')

exports.austria = require('./austria.json')
//exports.belgium = require('./belgium.json')
exports.bulgaria = require('./bulgaria.json')
exports.croatia = require('./croatia.json')
//exports.france = require('./france.json')
exports.germany = require('./germany.json')
exports.greece = require('./greece.json')
//exports.hungary = require('./hungary.json')
//exports.italy = require('./italy.json')
//exports.luxembourg = require('./luxembourg.json')
exports.netherlands = require('./netherlands.json')
//exports.poland = require('./poland.json')
//exports.portugal = require('./portugal.json')
exports.romania = require('./romania.json')
exports.slovenia = require('./slovenia.json')
exports.sweden = require('./sweden.json')
exports.switzerland = require('./switzerland.json')
exports.turkey = require('./turkey.json')